import React, { Component } from "react";
import AgentReceipt from "../components/Exchange/AgentReceipt";
import querySearch from "stringquery";

import { getExchangeTransaction } from "../services/ReportService";

export default class AgentExchangeReceipt extends Component {
	constructor() {
		super();
		this.state = { reportData: null };
	}
	componentDidMount() {
		const query = querySearch(window.location.search);
		getExchangeTransaction(query.tid, query.lang).then((res) => {
			this.setState({ reportData: res.data, urldata: query.v });
			document.title = "Agent_Exchange_Receipt_" + res.data.transactionNumber;
		});
	}
	render() {
		return this.state.reportData ? (
			<div style={{ height: "100%" }}>
				<AgentReceipt
					result={this.state.reportData}
					isBankCopy={false}
					copyPrint={this.state.urldata}
				/>
				<AgentReceipt result={this.state.reportData} isBankCopy={true} />
			</div>
		) : (
			<div></div>
		);
	}
}
